'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.buildActionsCollection = buildActionsCollection;
exports.getEndpoints = getEndpoints;
exports.changeWebAppUrl = changeWebAppUrl;
exports.isProdEnv = isProdEnv;

var _config = require('../../config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * buildActionsCollection() returns a function [action, props] which checks action against a collection of actions
 * and dispatches the action if found.
 * @param {Object} collection - plain object with actions
 * @param {function} dispatch - dispatch function for the store
 */
function buildActionsCollection(collection, dispatch) {
  return function (action) {
    if (typeof collection[action] !== 'undefined') {
      for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
      }

      return dispatch(collection[action].apply(collection, props));
    }
    throw Error('Invalid action creator');
  };
}

function getEndpoints(env) {
  switch (env) {
    case 'development':
      return _config.endpoints.development;
    case 'sandbox':
      return _config.endpoints.sandbox;
    case 'quality':
      return _config.endpoints.quality;
    case 'dev_production':
    case 'production':
      return _config.endpoints.production;
    default:
      return _config.endpoints.development;
  }
}

function changeWebAppUrl(env, name) {
  var baseUrl = 'https://' + name + '.adparlordev.com';
  var updatedEnv = (0, _assign2.default)({}, env, { web_app_url: baseUrl });
  return updatedEnv;
}

function isProdEnv() {
  return process.env.NODE_ENV === 'production';
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/js-anvil/lib/helpers/general/index.js
// module id = 6
// module chunks = 0